import { LoginDataPropsType } from "Context/types/LoginDataPropsType";

import { AffiliateAccountTypes } from "Types/enums";

export const DefaultLogin: LoginDataPropsType = {
  type                    : AffiliateAccountTypes.FULL,
  username                : "",
  fullName                : "",
  email                   : "",
  firstName               : "",
  middleName              : "",
  lastName                : "",
  language                : "",
  forceChangePassword     : false,
  lastLoginCity           : "",
  lastLoginCountry        : "",
  clientCurrencyCode      : "",
  clientLanguageCodes     : [],
  clientOTPEnabled        : false,
  OTPEnabled              : false,
  ip                      : "",
  token                   : "",
  profilePhoto            : "",
  OTP                     : null,
  device                  : {
    browser     : "",
    device      : "",
    isMobile    : false
  },
  location                : {
    city        : "",
    country     : ""
  },
  client                  : {
    id          : "",
    name        : "",
    slug        : "",
    siteName    : "",
    domain      : ""
  }
};